import { render, staticRenderFns } from "./WechatBar.vue?vue&type=template&id=184b4484&scoped=true&"
import script from "./WechatBar.vue?vue&type=script&lang=js&"
export * from "./WechatBar.vue?vue&type=script&lang=js&"
import style0 from "./WechatBar.vue?vue&type=style&index=0&id=184b4484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b4484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar})
